import { Collection } from 'modules/core/lib/mobx-rest'

import TaskFile from 'modules/tasks/store/models/TaskFile'

class TasksFiles extends Collection<TaskFile> {
  get cacheKey(): string {
    return 'tasksFiles'
  }

  model() {
    return TaskFile
  }
}

const singleton: TasksFiles = new TasksFiles()

export { TasksFiles }

export default singleton
